module.exports = __webpack_public_path__ + "e5781620820201f5f3ab198373eca556.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-baseball-s.png
// module id = 2710
// module chunks = 0